module.exports = __webpack_public_path__ + "static/media/SM-ST-7.9ef41548.mp3";